import { useAddUserGroup } from "../hooks/UserGroupHooks";
import { UserGroupDTO } from "../types/userGroupDTO";
import ValidationSummary from "../ValidationSummary";
import UserGroupForm from "./UserGroupForm";
import { toast } from 'react-toastify';
import { ClipLoader } from "react-spinners";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { useState } from "react";

const UserGroupAdd = () => {
    const { t } = useTranslation();
    const createValidToDate = () => {
        const date = new Date();
        date.setFullYear(2099);
        date.setSeconds(0, 0);
        return date;
    };
    const { organisationId } = useParams<{ organisationId: string }>();
    if (!organisationId) throw new Error("Missing organisationId from params");
    const [userGroup, setUserGroup] = useState<UserGroupDTO>({
        id: "00000000-0000-0000-0000-000000000000",
        organisationId: organisationId,
        name: "",
        validFrom: new Date(new Date().setSeconds(0, 0)),
        validTo: createValidToDate(),
        lastModified: new Date()        
    });

    const addUserGroupMutation = useAddUserGroup(organisationId, setUserGroup);

    return (
        <>
            {addUserGroupMutation.isError && (
                <ValidationSummary error={addUserGroupMutation.error} />
            )}
            {addUserGroupMutation.isPending ? (
                <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
                    <ClipLoader size={50} color={"#123abc"} loading={true} />
                    <p>{t('userGroup.addWait')}</p>
                </div>
            ) : (
                <UserGroupForm
                        headerText={t('userGroup.add')}
                    userGroup={userGroup}
                    submitted={(ug) => {
                        addUserGroupMutation.mutate(ug, {
                            onError: () => {
                                toast.error(t('userGroup.addError'));
                            },
                            onSuccess: () => {
                                toast.success(t('userGroup.addSuccess'));
                                history.back();
                            }
                        });
                    }}
                />
            )}
        </>
    );
};

export default UserGroupAdd;